import { Root } from "@/components/templates/Root";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$organizationKey/$dossierId/$researchProjectId/")({
  component: DashboardPage,
});

function DashboardPage() {
  const { researchProjectId } = Route.useParams();

  return <Root researchProjectId={Number.parseInt(researchProjectId)} />;
}
